<template>
  <div id="app">
    <div :class="dialogVisualizarQRcode.aberto || dialogGerarQRcode.aberto ? 'blur' : ''">
      <div class="header">
        <div>
          <h1>Home</h1>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>Dashboard</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>

      <el-row :gutter="30">
        <el-col :xs="24" :sm="8">
          <VisualizarQRcode :abrirDialog="dialogVisualizarQRcode" :qrcode_key="qrcode_key" />
        </el-col>

        <el-col :xs="24" :sm="8">
          <GerarQRcode :abrirDialog="dialogGerarQRcode" />
        </el-col>

        <el-col :xs="24" :sm="8">
          <div class="card pointer" @click="$router.push('colaboradores')">
            <div class="card-content">
              <div class="avatar">
                <span class="avatar-ini"><i class="fas fa-user"></i></span>
              </div>
              <div class="info">
                <p class="nome">Visualizar Colaboradores</p>
                <span class="subtitulo">Visualize e edite os colaboradores da empresa.</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="30">
        <el-col :xs="24" :sm="16">
          <el-row :gutter="30">
            <el-col :span="24">
              <PontosDia :dia="hoje" titulo="Pontos de Hoje" />
            </el-col>
            <el-col :span="24">
              <PontosDia :dia="ontem" titulo="Pontos de Ontem" />
            </el-col>
          </el-row>
        </el-col>

        <el-col :xs="24" :sm="8">
          <HorasMes />
        </el-col>
      </el-row>
    </div>

    <el-dialog title="QRcode" :visible.sync="dialogVisualizarQRcode.aberto">
      <p>Clique com o botão direito e mande fazer download da imagem.</p>
      <qrcode class="qrcode-download" :value="qrcode_key" :options="{ size: 400, }"></qrcode>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment-business-days';
import VisualizarQRcode from './visualizar-qrcode';
import GerarQRcode from './gerar-qrcode';
import PontosDia from './pontos-dia';
import HorasMes from './horas-mes';

export default {
  name: 'Home',
  components: {
    VisualizarQRcode, GerarQRcode, PontosDia, HorasMes
  },
  data() {
    return {
      dialogVisualizarQRcode: {
        aberto: false
      },
      dialogGerarQRcode: {
        aberto: false
      },
      qrcode_key: '',
      hoje: moment(),
      ontem: moment().subtract(1, 'day')
    };
  },
  created() {
    const ref = this.$db.ref('qrcode/');
    ref.on('value', snap => {
      if (snap.exists()) this.qrcode_key = Object.entries(snap.val())[0][0];
      else this.qrcode_key = '';
    });
  }
};
</script>

<style lang="scss" scoped>
::v-deep .qrcode {
  border-radius: 5px;
}

::v-deep h2 {
  margin-bottom: 8px;
}

::v-deep h3 {
  opacity: .5;
  font-weight: normal;
  margin-top: 0;
  text-transform: uppercase;
  font-size: 15px;
  letter-spacing: 1px;
}

::v-deep h4 {
  margin: 30px 0 20px;
  opacity: .5;
  font-weight: normal;
  font-size: 14px;
}

::v-deep .el-dialog__body {
  text-align: center;
  margin-bottom: 30px;
  padding-top: 0;

  p {
    margin-bottom: 30px;
    color: rgba(#fff, .6)
  }

  .qrcode-download {
    box-sizing: border-box !important;
    padding: 20px;
    margin: 0 -20px -20px;
    background: #fff;
    border-radius: 7px;
  }
}
</style>
